interface Config {
    apiUrl: string;
    defaultYear: number;
}
const config: Config = {
    apiUrl: process.env.REACT_APP_API_URL ?? "",
    defaultYear: Number(process.env.REACT_APP_DEFAULT_YEAR ?? "2024"),
}

export default config;